"use client";

import { cn } from "@kyan/ui";
import type { PointerEvent } from "react";

interface DragButtonProps {
  className?: string;
  showTradePanel: boolean;
  handleDrag: (e: PointerEvent<HTMLButtonElement>) => void;
}

export const DragButton: React.FC<DragButtonProps> = ({
  className,
  showTradePanel,
  handleDrag,
}) => {
  return (
    <div
      className={cn(
        "absolute top-0 left-1/2 hidden h-full -translate-x-1/2 flex-col justify-center",
        {
          "md:flex": !showTradePanel,
          "lg:flex": showTradePanel,
        },
      )}
    >
      <button
        className={cn(
          "group flex h-4 w-6 cursor-ns-resize touch-none flex-col justify-center",
          className,
        )}
        onPointerDown={handleDrag}
      >
        <span className="group-hover:bg-textPrimary bg-textSecondary h-1 w-full rounded-full border-none transition-colors" />
      </button>
    </div>
  );
};
